import { ContentState, convertFromRaw } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import $ from 'jquery';
import Slugger from 'github-slugger';
import { internalToAbsolute } from './linkUtilities';
import { ENTITY_TYPE, HEADER_TAGS, INLINE_REFERENCE_TYPE } from './CONSTANTS';
import { RESOURCE_TYPE } from '../../utilities/CONSTANTS';

const INLINE_REFERENCE_CUSTOM_CLASS = 'tettra-inline-reference';

const entityStylingFunction = (entity) => {
    const entityType = entity.get('type').toUpperCase();
    const data = entity.getData();

    if (entityType === ENTITY_TYPE.INLINE_REFERENCE) {
        const url = internalToAbsolute(data.url || '');
        const referenceType = data.referenceType || '';

        return {
            element: 'a',
            attributes: {
                href: url,
                class: `${INLINE_REFERENCE_CUSTOM_CLASS} ${referenceType}`,
            },
        };
    }

    if (entityType === ENTITY_TYPE.FILE) {
        const url = data.src;
        return {
            element: 'a',
            attributes: {
                href: url,
            },
        };
    }

    if (entityType === ENTITY_TYPE.EMBEDLY) {
        const embedlyData = data.embedly;
        if (embedlyData && embedlyData.html && (embedlyData.type === 'video' || embedlyData.type === 'rich')) {
            const wrappedDiv = $(`<div>${embedlyData.html}</div>`);
            const embedlyDataIframe = wrappedDiv.find('iframe').get(0);

            if (embedlyDataIframe) {
                return {
                    element: 'iframe',
                    attributes: {
                        src: embedlyDataIframe.src,
                        width: embedlyData.width,
                        height: embedlyData.height,
                        allow: embedlyDataIframe.allow || 'autoplay; fullscreen',
                        frameborder: embedlyDataIframe.getAttribute('frameborder') || '0',
                    },
                };
            }
        }
        return {
            element: 'iframe',
            attributes: {
                src: data.src,
            },
        };
    }

    return null;
};

const blockRenderer = (editorState) => (block) => {

    const options = {
        entityStyleFn: entityStylingFunction,
    };
    const data = block.getData();
    const rows = data.get('rows');
    if (rows) {
        const tableBody = rows.map(cells => (
            `<tr>${cells.map(cell => `<td>${stateToHTML(cell.getCurrentContent(), options)}</td>`)}</tr>`
        ));

        return `<table><tbody>${tableBody}<tbody></table>`;
    }
    const width = data.get('width');
    const height = data.get('height');
    const entityKey = block.getEntityAt(0);
    if (entityKey) {
        const entity = editorState.getCurrentContent().getEntity(entityKey);
        const type = entity.get('type').toUpperCase();
        const entityData = entity.getData();

        if (width || height) {
            if (type === ENTITY_TYPE.IMAGE) {
                const url = entityData.src;

                return `<img width="${width || height}" height="${height || width}" src="${url}" />`;
            }

            if (type === ENTITY_TYPE.IFRAME) {
                const url = entityData.src;

                return `<iframe width="${width || height}" height="${height || width}" src="${url}" />`;
            }
        }
        if (type === ENTITY_TYPE.HR) {
            return '<hr>';
        }
    }

    return null;
};

const callOutRenderer = (block) => {
    const data = block.getData();
    const color = data.get('color', 'blue');
    const classes = `callout-block callout-${color}`;

    const singleBlockContentState = ContentState.createFromBlockArray([block]);

    const html = stateToHTML(singleBlockContentState, {});

    return `<div class="${classes}"><span>${html}</span></div>`;
};

const headerRenderer = (slugger) => (block) => {
    const tag = HEADER_TAGS[block.getType()];
    const text = block.getText();
    if (!text) {
        return null;
    }
    const id = slugger.slug(text);
    return (`
        <${tag} id="${id}">
            ${text}
            <a class="header-link" href="#${id}"/>
        </${tag}>`
    );
}

const getOptions = (editorState) => {
    const slugger = new Slugger();
    return {
        entityStyleFn: entityStylingFunction,
        blockRenderers: {
            atomic: blockRenderer(editorState),
            callout: callOutRenderer,
            "header-one": headerRenderer(slugger),
            "header-two": headerRenderer(slugger),
            "header-three": headerRenderer(slugger),
        },
    }
};


const adjustInlineReferenceLinks = (html) => {
    const refs = [
        {
            type: INLINE_REFERENCE_TYPE.PAGE_REFERENCE,
            img: "/img/file-icon-page.png"
        },
        {
            type: RESOURCE_TYPE.TETTRA_QUESTION,
            img: "/img/file-icon-question.png"
        }
    ];
    refs.forEach(ref => {
        const refRegex = new RegExp(`(<a [^>]*class="${INLINE_REFERENCE_CUSTOM_CLASS} ${ref.type}"[^>]*>)([^<])`, 'g');
        const refReplacement = `$1<img src="${ref.img}" class="inline-reference" />`;
        html = html.replace(refRegex, refReplacement);
    });
    return html;
};

const editorStateToHTML = (editorState) => {
    if (!editorState || !Object.keys(editorState).length) {
        return null;
    }

    const htmlOutput = stateToHTML(editorState.getCurrentContent(), getOptions(editorState)).replace(/\n/g, '');

    return adjustInlineReferenceLinks(htmlOutput);
};

export default editorStateToHTML;

